<script setup lang="ts">
interface VDividerProps {
  vertical?: boolean
  label?: string
}

const props = defineProps<VDividerProps>()

const { t, te } = useI18n()

const computedLabel = computed(() =>
  props.label && te(props.label) ? t(props.label) : props.label
)
</script>

<template>
  <div
    v-if="vertical"
    class="divider vertical"
    :data-content="computedLabel"
    role="separator"
  />
  <div
    v-else-if="computedLabel"
    class="divider"
    :data-content="computedLabel"
    role="separator"
  />
  <hr v-else class="divider" />
</template>

<style scoped></style>
